module.exports = __webpack_public_path__ + "media/images/flags/4x3/swe-2c17c00bbd6e25728902004d90b2dd93.svg";